export default __webpack_public_path__ + "static/media/CSIs.621b1588.png";